// DATE UTILS
import {
  defaultCheckinOffset,
  defaultCheckoutOffset,
  parseUrlDateString,
} from './../../../utils/date-utils';

// UTILS
import {get_queryParameters} from '../../../utils/common-utils';
import {addDays} from '../../../utils/date-utils';

// TYPE GUARDS
import {isDefined} from '../../../../types/type-guards';

// TYPES
import {ICheckinCheckoutDate} from './../../common/redux/types';

// CONFIG
import {defaultPartner, defaultRoomString} from './../../../config/app-config';

export function parseDetailsPageUrlToConfig(url, params) {
  const {hotelNameSlug = '', hotelId = ''} = params;
  const hotelName = hotelNameSlug.replace(/[^\w\s]/gi, ' ');
  const hc = hotelId;
  const hn = hotelName;

  // removed once the getParams changes are done
  let hquery = params?.hotelQuery || get_queryParameters('hquery', url) || '';
  const hctx = get_queryParameters('hctx', url);
  const sctx = get_queryParameters('sctx', url);
  const hmd = get_queryParameters('hmd', url);
  const offerCodeFromQueryParam = get_queryParameters('offerCode', url);
  const metaPartner = get_queryParameters('metaTraffic', url);
  const appliedFiltersQueryParam = decodeURIComponent(get_queryParameters('appliedFilters', url));
  const appliedFilters = JSON.parse(appliedFiltersQueryParam);

  let defaultCheckinDate = addDays(new Date(), defaultCheckinOffset);
  let defaultCheckoutDate = addDays(new Date(), defaultCheckoutOffset);

  let checkin: ICheckinCheckoutDate = {date: defaultCheckinDate};
  let checkout: ICheckinCheckoutDate = {date: defaultCheckoutDate};

  let roomString: string = defaultRoomString;
  let ibp: string = '';

  if (isDefined(hquery) && hquery.length > 0) {
    try {
      let {ci = '', co = '', r = defaultRoomString, ld = '', ibp: hqueryIbp = ''} = JSON.parse(
        decodeURIComponent(hquery),
      );
      let relChIn = new Date();
      let relChout = addDays(relChIn, 1);

      if (ld) {
        // seo ld handling
        const offset = parseInt(ld, 10);
        relChIn = addDays(new Date(), offset);
        relChout = addDays(new Date(), offset + 1);
      }
      checkin.date = ci ? parseUrlDateString(ci) : relChIn;
      checkout.date = co ? parseUrlDateString(co) : relChout;

      ibp = hqueryIbp ? hqueryIbp : '';

      roomString = r ? r : defaultRoomString;
    } catch (err) {
      // ! must allow flow to continue even after error with defaults, if possible
      console.error(err);
    }
  }

  let filter = {};

  // ! when are the following filled ?
  if (hctx) {
    filter = {hctx};
  }

  if (sctx) {
    filter = {
      ...filter,
      sctx: sctx.split(','),
    };
  }

  return {
    vhid: hc,
    roomString,
    ibp,
    metaPartner,
    filter,
    checkin,
    checkout,
    offerCodeFromQueryParam,
    appliedFilters,
    selectedHotelStatic: {
      hn,
      hc,
      ibp,
      hmd,
    },
  };
}
